import React from 'react';
import styles from './RestrictionAlert.module.scss';
import { PurchaseLot } from '../../../types/entities';
import { flatMap } from 'lodash';
import Link from 'next/dist/client/link';

interface Props {
    lots: PurchaseLot[];
}

export const RestrictionAlert: React.FC<Props> = ({ lots }) => {
    const restrictions: PurchaseLot['restrictions'] = flatMap(
        lots,
        'restrictions'
    ).filter(Boolean);

    return (
        <div className={styles.container}>
            <p>
                Для получения остальной информации о закупке, Вам нужно пройти
                дополнительный отбор:
            </p>
            {restrictions.length &&
                restrictions.map((restriction) => (
                    <div key={restriction.id}>
                        <Link
                            href={`/purchases/${restriction.relationLot.announce.id}/main`}
                        >
                            {`${restriction.relationLot.number}: ${restriction.relationLot.title}`}
                        </Link>
                    </div>
                ))}
        </div>
    );
};
